import DeviceManager from '../utils/device-manager';

if(window.history && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

const scrollTo = ($target) => {
    let paddingOffset = window.getComputedStyle(document.documentElement, null).getPropertyValue('scroll-padding-top');
    if(paddingOffset) {
        paddingOffset = parseFloat(paddingOffset);
    }
    
    if(DeviceManager.supportsScrollBehavior()) {
        window.scrollTo({top: $target.offset().top - paddingOffset, behavior: 'smooth'});
    }
    else {
        window.scrollTo($target.offset().top - paddingOffset, 0);
    }
};
const scrollToAnchor = (hash, usePushState = false) => {
    const $target = $(hash); 

    if($target.length) {
        if(usePushState && DeviceManager.supportsHistory()) {
            window.history.pushState(null, null, hash);
        }

        if($target.is('.accordion')) {
            $(window).trigger('accordion:open', {$el: $target});
            // We wait until the accordion is opened before scrolling to its position
            setTimeout(scrollTo.bind(this, $target), 50);
        }
        else {
            scrollTo($target);
        }
        
        return false;
    }
};
const onPopState = (e) => {
    if(window.location.hash) {
        scrollToAnchor(window.location.hash);
    }
};
const initScrollToAnchor = (e) => {
    if(window.location.hash) {
        scrollToAnchor(window.location.hash, true);
    }
};

const $anchorLinks = $('a[href^="#"]:not([href="#"])');
if($anchorLinks.length) {
    $anchorLinks.on('click', (e) => {
        e.preventDefault();
        
        scrollToAnchor(e.currentTarget.hash, true);
    });
}

window.addEventListener('popstate', onPopState);

export default initScrollToAnchor;